/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseenterapricegreaterthan05Inputs */

const en_pleaseenterapricegreaterthan05 = /** @type {(inputs: Pleaseenterapricegreaterthan05Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a price greater than 0 (use Free for no cost)`)
};

const de_pleaseenterapricegreaterthan05 = /** @type {(inputs: Pleaseenterapricegreaterthan05Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib einen Preis über 0 ein (für keinen Preis nimm Kostenlos)`)
};

/**
* | output |
* | --- |
* | "Please enter a price greater than 0 (use Free for no cost)" |
*
* @param {Pleaseenterapricegreaterthan05Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseenterapricegreaterthan05 = /** @type {((inputs?: Pleaseenterapricegreaterthan05Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseenterapricegreaterthan05Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseenterapricegreaterthan05(inputs)
	return de_pleaseenterapricegreaterthan05(inputs)
});
export { pleaseenterapricegreaterthan05 as "pleaseEnterAPriceGreaterThan0" }